const gameServicesData = [
  {
    title: "3D Game App Development",
    description:
      "Create visually striking 3D games with advanced graphics and creative interfaces that keep players engaged.",
    bullets: [
      "Optimised Performance",
      "Engaging Storylines",
      "Dynamic Environments",
      "Cutting-edge 3D visuals",
    ],
    minHeight: 400,
  },
  {
    title: "Mobile Game Development",
    description:
      "High-quality games for iOS and Android with smooth gameplay and interactive experiences.",
    bullets: [
      "Multi-Platform Expertise",
      "Cross-Platform Game Development",
      "Ongoing Support and Game Updates",
      "Realistic Gameplay",
    ],
    minHeight: 400,
  },
  {
    title: "Web3 Game Development",
    description:
      "Innovative games using blockchain for secure, community-driven economies and engagement.",
    bullets: [
      "Blockchain-Based Development",
      "Decentralized Gaming Platforms",
      "Web3 Wallet Integration",
      "Community-Driven Development",
    ],
    minHeight: 400,
  },
  {
    title: "AR/VR Game App Development",
    description:
      "Immersive AR/VR experiences with realistic visuals, interactions, and multi-platform support.",
    bullets: [
      "AR/VR Game Design",
      "Integration with AR/VR Hardware",
      "Motion Tracking and Haptics",
      "Realistic Visuals and Interactions",
    ],
    minHeight: 400,
  },
  {
    title: "Metaverse Game Development",
    description:
      "Build next-level metaverse services for P2E, PvP, and engaging community spaces.",
    bullets: [
      "AI-Powered NPCs",
      "Smart Contract Development",
      "Decentralized Virtual Real Estate",
      "Scalable Worlds",
    ],
    minHeight: 400,
  },
  {
    title: "NFT Game App Development",
    description:
      "End-to-end development for NFT-based games enabling minting, trading, and in-game economies.",
    bullets: [
      "NFT Minting & Integration",
      "Unique In-Game Assets",
      "Secure Wallet Integration",
      "Scalable Backend Infrastructure",
    ],
    minHeight: 400,
  },
];

// 🔹 Game Technology / Stack Section
export const gameTechData = [
  {
    label: "Unreal Engine",
    color: "#0b0b0b",
    text: "Delivers stunning graphics and immersive experiences with high performance.",
    icon: "fa-solid fa-atom",
  },
  {
    label: "Unity",
    color: "#6b6b6b",
    text: "Versatile and powerful for creating both 2D and 3D games across multiple platforms.",
    icon: "fa-solid fa-cubes",
  },
  {
    label: "HTML5",
    color: "#ff6d2e",
    text: "Modern web technologies for lightweight, portable browser-based games.",
    icon: "fa-brands fa-html5",
  },
  {
    label: "CryEngine",
    color: "#111111",
    text: "High-end visuals and performant rendering for realistic worlds.",
    icon: "fa-solid fa-eye",
  },
  {
    label: "C++",
    color: "#5966d6",
    text: "Low-level control and performance for engine and gameplay systems.",
    icon: "fa-solid fa-code",
  },
  {
    label: "Swift",
    color: "#ff4b2b",
    text: "Modern iOS/macOS development with strong performance for responsive games.",
    icon: "fa-solid fa-bolt",
  },
  {
    label: "C#",
    color: "#3f7bd6",
    text: "Productive scripting for Unity and tool pipelines.",
    icon: "fa-solid fa-hashtag",
  },
  {
    label: "Godot",
    color: "#6f7dc8",
    text: "Open-source engine with flexible workflows for 2D and 3D projects.",
    icon: "fa-solid fa-robot",
  },
];

// Game Genres
 export const gameGenres = [
  {
    label: "Board Games",
    src: "/assets/img/gamesimg/Board-Games.webp",
  },
  {
    label: "Action Games",
    src: "/assets/img/gamesimg/Action-Games.webp",
  },
  {
    label: "Roleplay Games",
    src: "/assets/img/gamesimg/Roleplay-Games.webp",
  },
  {
    label: "Sports",
    src: "/assets/img/gamesimg/Sports.webp",
  },
  {
    label: "Adventure Games",
    src: "/assets/img/gamesimg/Adventure-Games.webp",
  },
  {
    label: "Battle Royale",
    src: "/assets/img/gamesimg/Battle-Royale.webp",
  },
  {
    label: "Racing Games",
    src: "/assets/img/gamesimg/Racing-Games.webp",
  },
  {
    label: "Puzzle Games",
    src: "/assets/img/gamesimg/Puzzle-Games.webp",
  },
];

export default gameServicesData;
